export default __webpack_public_path__ + "static/media/logo-patrocinador.1b85e4ab.svg";